var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.posts
    ? _c(
        "div",
        {
          staticClass: "trends Tends-Horizontal mb-6",
          attrs: {
            "data-epica-module-name": "Tendencias",
            "data-mrf-recirculation": "Tendencias",
          },
        },
        [
          _c("h3", { staticClass: "heading-title mb-3" }, [
            _vm._v("TENDENCIAS"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "double-line" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row mt-5 row-cols-3" },
            _vm._l(_vm.posts, function (post, idx) {
              return _c("div", { key: post.id, staticClass: "col newsTends" }, [
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", {
                    staticClass: "numberTends mr-3",
                    domProps: { innerHTML: _vm._s(idx + 1) },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "V_Title" }, [
                      _c("a", {
                        staticClass: "kicker",
                        class: post.className,
                        attrs: { href: post.url },
                        domProps: { innerHTML: _vm._s(post.header) },
                      }),
                      _vm._v(" "),
                      _c("h2", { staticClass: "tt" }, [
                        _c("a", {
                          class: post.className,
                          attrs: { href: post.url },
                          domProps: { innerHTML: _vm._s(post.title) },
                        }),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            }),
            0
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }